import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";
import { useArenaAccessByUsersQuery } from "~/graphql/supergraphHooks";
import { useDateFormatterWithTimezone } from "~/pages/UserAndRoles/utils/dateFormatter";

export type WpAssignedUserRow = {
  fullName: string;
  globalUserId: string;
  adminArenaUserId: string;
  emailAddress: string;
  activeWorkspaces: number;
  lastAccessTimestamp: string;
};

export const useWpAssignedUsersTableAgGridOptions = () => {
  const columnDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "globalUserId",
        headerName: "User ID",
        filter: "agNumberColumnFilter",
      },
      {
        field: "fullName",
        headerName: "User",
        filter: "agTextColumnFilter",
      },
      {
        field: "emailAddress",
        headerName: "Email",
        filter: "agTextColumnFilter",
      },
      {
        field: "activeWorkspaces",
        headerName: "Active workspaces",
      },
      {
        field: "lastAccessTimestamp",
        headerName: "Last access",
      },
    ];
  }, []);

  return { columnDefs };
};

export const useFetchAssignedUsersByRoleName = (roleName?: string) => {
  const { formatDateWithTimezone } = useDateFormatterWithTimezone();
  const useArenaAccessByUsersQueryResult = useArenaAccessByUsersQuery({
    variables: {
      filters: {
        roleGroupName: roleName!,
      },
    },
    skip: roleName === undefined,
  });

  const rowData: WpAssignedUserRow[] = useMemo(() => {
    if (
      useArenaAccessByUsersQueryResult.data?.arenaAccessByUsers?.__typename ===
      "ArenaAccessByUsersOutput"
    ) {
      return useArenaAccessByUsersQueryResult.data.arenaAccessByUsers.users.map((user) => ({
        fullName: user.fullName,
        globalUserId: user.globalUserId,
        adminArenaUserId: user.adminArenaUserId,
        emailAddress: user.emailAddress,
        activeWorkspaces: user.activeWorkspaces || 0,
        lastAccessTimestamp: formatDateWithTimezone(user.lastAccessTimestamp ?? undefined),
      }));
    }
    return [];
  }, [useArenaAccessByUsersQueryResult.data]);

  return { rowData, useArenaAccessByUsersQueryResult };
};
